import { ConfigurationKey } from '../reducers/configurationsSlice'
import { User } from '../types'
import { Role } from './roleUtils'

export type NewsfeedConfig = Readonly<{
  name: string
  linkKey: ConfigurationKey
  showCriticality: boolean
}>

const loviConfig = {
  name: 'Lovi',
  linkKey: 'veksiLink',
  showCriticality: false,
} as const

const lahiveksiConfig = {
  name: 'LähiVeksi',
  linkKey: 'lahiVeksiLink',
  showCriticality: true,
} as const

const kaukoliikenteenIlmoitustauluConfig = {
  name: 'Ilmoitustaulu',
  linkKey: 'kaukoliikenteenIlmoitustauluLink',
  showCriticality: true,
} as const

const newsfeedConfig: Partial<Record<Role, NewsfeedConfig>> = {
  driver: loviConfig,
  logistics_driver: loviConfig,
  commuter_driver: lahiveksiConfig,
  commuter_manager: lahiveksiConfig,
  conductor: kaukoliikenteenIlmoitustauluConfig,
  waiter: kaukoliikenteenIlmoitustauluConfig,
}

export const getNewsfeedConfig = (user: User): NewsfeedConfig | undefined =>
  Object.entries(newsfeedConfig).find(([role]) => user[role])?.[1]
